import type { PostContentJson } from '@_/types';
import type { MutationStatus } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { useEffect } from 'react';

type CommentPayload = {
  contentJson: PostContentJson;
  parentCommentId?: string;
  postId: string;
};

export interface UseCommentMutationOptions<TComment> {
  createComment: (data: CommentPayload) => Promise<TComment>;
  onStatusChange?: (status: MutationStatus) => void;
  onSuccess?: (data: TComment) => void;
}

export function useCommentMutation<TComment>({
  createComment,
  onStatusChange,
  onSuccess
}: UseCommentMutationOptions<TComment>) {
  const mutation = useMutation({
    mutationFn: createComment,
    onSuccess
  });

  const { status } = mutation;

  useEffect(() => {
    onStatusChange?.(status);
  }, [onStatusChange, status]);

  return mutation;
}
